var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(
      _vm.backendStatus === 'migration-required' ||
      _vm.backendStatus === 'sys-admin-required'
    )?_c('AMaintenanceOngoingInfo',{staticClass:"mx-auto",attrs:{"db-versions":_vm.dbVersions},on:{"reload":_vm.reloadApp}}):_vm._e(),(_vm.backendStatus === 'ready')?_c('AMaintenanceCompleteInfo',{staticClass:"mx-auto",on:{"reload":_vm.reloadApp}}):_vm._e(),(_vm.backendStatus == 'system-init')?_c('ASysAdminInitForm'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }